<template>
  <section>
    <div class="pop-room material-detail-pop" v-if="detailStatus">
      <a href="javascript:;" @click="closeDetailStatus()" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <h3 class="title">
          维修/领用材料出库单
          <span style="margin-left:10px;position:relative;top:-3px;">
            <a v-if="!isMobile" :href="baseURL + '/storage/material/out/order/download?outId=' + materialOutData.id"
              target="_blank">
              <!-- 负责人、审批人、管理员可以下载 -->
              <!-- SYSTEM_2 单独设置的下载权限 -->
              <el-button type="success" icon="el-icon-download" size="mini">表格下载</el-button>
            </a>

            <!-- 打印 -->
            <el-button @click="print()" type="primary" icon="el-icon-printer" size="mini">打印格式</el-button>
          </span>
        </h3>
        <el-col :span="23" v-if="materialOutData">
          <el-form ref="form" label-width="110px" class="form info-txt-center" style="padding-top:0;">
            <el-form-item label="维修/领用单号:">
              {{materialOutData.number}}
            </el-form-item>
            <el-form-item label="出库仓库:">
              {{materialOutData.house.name}}
            </el-form-item>
            <el-form-item label="出库类型:">
              {{materialOutData.type}}
            </el-form-item>
            <el-form-item label="领用人:">
              <user-info :userData='materialOutData.user'></user-info>
            </el-form-item>
            <el-form-item label="出库管理员:">
              <user-info :userData='materialOutData.creator'></user-info>
            </el-form-item>
            <el-form-item label="出库时间:">
              {{materialOutData.outTime}}
            </el-form-item>
            <el-form-item label="用途简述:">
              {{materialOutData.purpose}}
            </el-form-item>

            <el-form-item class="full" label="材料明细:">
              <div class="material-table">
                <el-table :data="materialOutData.materials" border>
                  <el-table-column prop="number" label="材料编号">
                  </el-table-column>
                  <el-table-column prop="name" label="明细名称" width="240">
                  </el-table-column>
                  <el-table-column prop="dlName" label="材料类别" width="200">
                  </el-table-column>
                  <!-- <el-table-column prop="amount" align="center" label="数量">
                  </el-table-column> -->
                  <el-table-column prop="unitName" align="center" label="计量单位">
                  </el-table-column>

                  <el-table-column prop="" align="center" label="数量">
                    <template slot-scope="scope">
                      {{ scope.row.amount && parseFloat(scope.row.amount).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="" align="center" label="单价(元)">
                    <template slot-scope="scope">
                      {{ scope.row.price && parseFloat(scope.row.price).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="totalPrice" align="center" label="总价(元)">
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
  </section>
</template>
<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  export default {
    computed: {
      ...mapState({
        isMobile: state => state.main.isMobile,
      })
    },
    components: {
      UserInfo,
    },
    props: ['detailStatus', 'materialOutData'],
    data() {
      return {
        baseURL: axios.defaults.baseURL,
      }
    },
    methods: {
      // 打印
      print() {
        let _printData = {
          type: 'materialOut',
          data: this.materialOutData,
          isPrint: true,
        }
        this.$store.commit('set_printData', _printData)
      },
      closeDetailStatus() {
        this.$emit("hideDetail")
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/storage/components/materialOutDetail.vue